import React from 'react';
import classnames from 'classnames';
import Cover from '../../Basic/Cover';
import Tag from '../../Basic/Tag';

import './style.scss';

const PREFIX = 'music';

export interface SongAlbumCardProps {
  /** 封面图片 URL */
  coverUrl?: string;
  /** 歌曲/专辑标题 */
  title: string;
  /** 艺术家名称 */
  artist?: string;
  /** 曲目数量 */
  trackCount?: number;
  /** 标签列表 */
  tags?: string[];
  /** 自定义类名 */
  className?: string;
  /** 点击回调 */
  onClick?: () => void;
}

export default function SongAlbumCard({
  coverUrl,
  title,
  artist,
  trackCount,
  tags = [],
  className,
  onClick,
}: SongAlbumCardProps) {
  return (
    <div
      className={classnames(
        `${PREFIX}-song-album-card`,
        { [`${PREFIX}-song-album-card--clickable`]: !!onClick },
        className
      )}
      onClick={onClick}
    >
      <Cover src={coverUrl} size="large" />
      <div className={`${PREFIX}-song-album-card__content`}>
        <h3 className={`${PREFIX}-song-album-card__title`}>{title}</h3>
        {artist && <p className={`${PREFIX}-song-album-card__artist`}>{artist}</p>}
        {trackCount !== undefined && (
          <p className={`${PREFIX}-song-album-card__tracks`}>{trackCount} tracks</p>
        )}
        {tags.length > 0 && (
          <div className={`${PREFIX}-song-album-card__tags`}>
            {tags.map((tag, index) => (
              <Tag key={index}>{tag}</Tag>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
